<template>
  <div class="saf-each-checklist row">
    <div style="width: 85%">
      <slot />
      <div v-if="attachments.length > 0">
        <div v-for="(cItem, idx) in attachments" :key="`${doc}-${idx}`">

	        <div v-if="cItem.attType === doc">
		        <!-- file with  saveApplicationAttachment api-->
            <div class="upload-file-item">
              <span>-</span><a :href="cItem.APAT_FilePath" target="_blank">{{ cItem.APAT_EnrolFileName }}{{cItem.APAT_EnrolFileExt}}</a>
              <span class="checklist-remove-file" @click="$emit('remove',cItem, cItem.attType)">x</span>
            </div>
		        <!-- file with  saveApplicationAttachment api-->

						<!--<div class="upload-file-item" v-for="(fItem, idx) in cItem.attFile" :key="`${doc}_item-${idx}`">
			        <span>-</span><a :href="fItem.url" target="_blank">{{ fItem.name }}</a>
			        <span class="checklist-remove-file" @click="$emit('remove',fItem, cItem.attType)">x</span>
		        </div>-->
          </div>
        </div>
      </div>
    </div>

    <div style="width: 10%; margin-left: auto">
      <div class="saf-each-img-div">
        <input type="file" multiple hidden
               :id="`FU_${doc}`"
               @change="$emit('add',$event, doc)"
               onclick="this.value = null" />

        <label class="saf-each-attach-label"
               :for="`FU_${doc}`">
          <img class="saf-each-img" src="../../../assets/VectorAttach.png"/>
        </label>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: ['attachments', 'doc']
}
</script>